import classNames from 'classnames';
import I18n from 'i18n-js';
import { object, string } from 'prop-types';
import QRCode from 'qrcode.react';

import NewTabOpener from '~/components/NewTabOpener';

import { ReactComponent as Copy } from '~/assets/images/loot-cards/copy.svg';
import { ReactComponent as Gift } from '~/assets/images/loot-cards/gift.svg';
import { ReactComponent as Lock } from '~/assets/images/loot-cards/lock.svg';

import styles from './Code.module.scss';

function Code({ cardTemplate, rewardCode }) {
  return (
    <div className={styles.scratchCardCodeContainer}>
      <div className={styles.scratchCardLegend}>
        <Lock className={classNames(styles.codeLockIcon, styles.lockIcon)} />
        <p className={styles.scratchCardLabelText}>
          {I18n.t('RewardCodeView_label_code')}
        </p>
        <Gift className={styles.giftIcon} />
      </div>
      <p
        className={classNames(
          styles.scratchCardButtonLegend,
          styles.scratchCardCodeLegend,
        )}
      >
        {I18n.t('RewardCodeView_label_default')}
      </p>
      <div className={styles.scratchCardCode}>
        <p className={styles.scratchCardCodeText}>
          {rewardCode || 'XXXX-XXXX-XXXX-XXXX-XXXX'}
          <Copy
            className={styles.copyIcon}
            onClick={() => {
              navigator.clipboard.writeText(
                rewardCode || 'XXXX-XXXX-XXXX-XXXX-XXXX',
              );
            }}
          />
        </p>
        {rewardCode && cardTemplate.isQRCode && (
          <QRCode
            level="H"
            value={rewardCode || 'XXXX-XXXX-XXXX-XXXX-XXXX'}
          />
        )}
        {rewardCode && cardTemplate.isSteamCode && (
          <NewTabOpener
            className={styles.steamButton}
            href={`https://store.steampowered.com/account/registerkey?key=${rewardCode}`}
          >
            {I18n.t('RewardCodeView_steam_button_title')}
          </NewTabOpener>
        )}
      </div>
    </div>
  );
}

Code.propTypes = {
  cardTemplate: object,
  rewardCode: string,
};

export default Code;
